
import axios from 'axios'
import APP_CONSTANT from '../../config/constants';
import { LOCAL_STORAGE } from '../utils/constants';

const ReadAxios = async function (props = {}) {
    var gett = LOCAL_STORAGE.userToken;
    var customerNo = LOCAL_STORAGE.customerNo;
    var userId = LOCAL_STORAGE.userId;
    var startDate = props.startDate;
    var endDate = props.endDate;
    let congData = JSON.stringify
        ({
            customerNumber: +customerNo,
            customerNo: +customerNo,
            userId: +userId,
            startDate: startDate,
            endDate: endDate,
            ...props.readItems
        })
    let getData = []
    let permissions = []
    try {
        let response = await axios.post(props.url ? `${APP_CONSTANT.BASE_COMMON}masters/${props.url}` : `${APP_CONSTANT.BASE_COMMON}${props.mHurl}`, congData, { headers: { 'content-type': 'application/json', 'Authorization': `${gett}` } });
        if (response.status === 200 && response.data.resultSet !== "") {
            getData = response.data.resultSet
            permissions = response.data
        }
        return getData ? getData : permissions;
    }
    catch (e) {
        getData = e;
        return getData
    }
}


export default ReadAxios

export const GETMETHODREAD = async function (props = {}) {
    var gett = LOCAL_STORAGE.userToken;
    var customerNo = LOCAL_STORAGE.customerNo;
    var userId = LOCAL_STORAGE.userId;
    let newUrl = `${APP_CONSTANT.BASE_URL}${props.newUrl}`
    let link = `${APP_CONSTANT.BASE_URL}masters/${props.url}`
    try {
        await axios.get(`${newUrl ? newUrl : link}?customerNumber=${customerNo}&userId=${userId}&customer_no=${customerNo}&customerNo=${customerNo}`, { headers: { 'content-type': 'application/json', 'Authorization': `${gett}` } }).then((response) => {
            if (response.status === 200) {
                props.response(response)
            }
        })
    }
    catch (e) {
        return console.log('ErrorRead', e);
    }
}
export const GetCommonBaseURL = async function (props = {}) {
    var gett = LOCAL_STORAGE.userToken;
    var customerNo = LOCAL_STORAGE.customerNo;
    var userId = LOCAL_STORAGE.userId;
    let newUrl = `${process.env.REACT_APP_BASE_COMMON}/${props.newUrl}`
    try {
        await axios.get(`${newUrl}?customerNumber=${customerNo}&userId=${userId}&customer_no=${customerNo}&customerNo=${customerNo}&mainUserId=${props.mainUserId}&billingPartyId=${props.billingPartyId}`, { headers: { 'content-type': 'application/json', 'Authorization': `${gett}` } }).then((response) => {
            if (response.status === 200) {
                props.response(response)
            }
        })
    }
    catch (e) {
        return console.log('ErrorRead', e);
    }
}
export const GetBaseUrl = async function (props = {}) {
    var gett = LOCAL_STORAGE.userToken;
    var customerNo = LOCAL_STORAGE.customerNo;
    var userId = LOCAL_STORAGE.userId;
    let congData = JSON.stringify
        ({
            customerNumber: +customerNo,
            customerNo: +customerNo,
            userId: +userId,
            ...props.readItems
        })
    try {
        await axios.post(`${APP_CONSTANT.BASE_COMMON}${props.url}`, congData, { headers: { 'content-type': 'application/json', 'Authorization': `${gett}` } }).then((response) => {
            if (response.status === 200) {
                props.response(response.data)
            }
        })
    }
    catch (e) {
        return console.log('ErrorRead', e);
    }
}

export const CommonGetApi = async function (props = {}) {
    var gett = LOCAL_STORAGE.userToken;
    var customerNo = LOCAL_STORAGE.customerNo;
    var userId = LOCAL_STORAGE.userId;
    var startDate = props.startDate;
    var endDate = props.endDate;
    let congData = JSON.stringify
        ({
            customerNumber: +customerNo,
            customerNo: +customerNo,
            userId: +userId,
            startDate: startDate,
            endDate: endDate,
            ...props.readItems
        })
    let getData = []
    let permissions = []
    try {
        let response = await axios.post(props.url ? `${APP_CONSTANT.BASE_COMMON}masters/${props.url}` : `${APP_CONSTANT.BASE_URL}/${props.mHurl}`, congData, { headers: { 'content-type': 'application/json', 'Authorization': `${props.mHurl ? '' : gett}` } });
        if (response.status === 200 && response.data.resultSet !== "") {
            getData = response.data.resultSet
            permissions = response.data
        }
        return getData ? getData : permissions;
    }
    catch (e) {
        return console.log('ErrorRead', e);
    }
}

export const PutAPI = async function (props = {}) {
    var gett = LOCAL_STORAGE.userToken;
    var customerNo = LOCAL_STORAGE.customerNo;
    var userId = LOCAL_STORAGE.userId;
    let congData = JSON.stringify
        ({
            customerNumber: +customerNo,
            customerNo: +customerNo,
            userId: +userId,
            ...props.readItems
        })
    let getData = []
    let permissions = []
    try {
        let response = await axios.put(`${APP_CONSTANT.BASE_COMMON}masters/${props.url}`, congData, { headers: { 'content-type': 'application/json', 'Authorization': `${gett}` } });
        if (response.status === 200 && response.data.resultSet !== "") {
            getData = response.data.resultSet
            permissions = response.data
        }
        return getData ? getData : permissions;
    }
    catch (e) {
        return console.log('ErrorRead', e);
    }
}
